// Camlize a string, e.g. be able to make field name from title dynamically
// "Start Date" => "startDate"
// https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
export function camelize(str: string) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

// format number values for on-screen display
export function formatNumber(value: number | string) {
  return typeof value === "number" ? value.toLocaleString() : value;
}